import * as CryptoJS from 'crypto-js';

import { GlobalVariable } from './settings';
export function encrypt(txt: string): string {
	return CryptoJS.AES.encrypt(txt, GlobalVariable['SECRET']).toString();
}

export function decrypt(txtToDecrypt: string) {
	return CryptoJS.AES.decrypt(txtToDecrypt, GlobalVariable['SECRET']).toString(CryptoJS.enc.Utf8);
}
